import { ITPAMSReportsState } from '../state';
import { AsyncActionState } from '@telstra-connect/standard-actions/async-action';

export const initialState: Readonly<ITPAMSReportsState> = Object.freeze({
    summary: {
        status: AsyncActionState.NotStarted,
        data: {
            reportsCount: 0,
            lastAddedDate: ''
        }
    },
    reports: {
        status: AsyncActionState.NotStarted,
        data: {
            TPAMSReports: [
                {
                    createdOn: '',
                    reportId: '',
                    reportName: ''
                }
            ]
        }
    },
    monthlyReports: {
        status: AsyncActionState.NotStarted,
        data: {
            TPAMSMonthlyReports: [
                {
                    kbNumber: '',
                    month: '',
                    year: ''
                }
            ]
        }
    }
});
